import DropdownControl from "../../../../../shared/ui/form/DropdownControl";
import {FilterFieldTypeEnum, FilterRangeType} from "../../../model/filter-types";
import RangeSlider from "../groups/RangeSlider";
import {IsValidRangeUtil} from "../../../../../shared/utils/isValidRangeUtil";
import {OnChangeFilterHandler} from "../../../model/useFilterHandler";

interface IProps {
    keyField: string;
    field: FilterRangeType;
    filedState: string[] | number[];
    onChangeHandler: OnChangeFilterHandler;
}

/**
 * Компонент для отображения диапазона значений (range slider) внутри фильтра.
 * Используется для числовых фильтров, таких как цена,.
 *
 * Преобразует строковые значения из состояния (например, '>100', '<500') в числовой диапазон,
 * и передаёт их в RangeSlider.
 *
 * @param keyField - Ключ фильтра (идентификатор поля)
 * @param field - Конфигурация поля диапазона (минимум, максимум, заголовок)
 * @param filedState - Состояние диапазона в виде массива [min, max]
 * @param onChangeHandler - Обработчик изменения диапазона
 *
 * @returns JSX-элемент DropdownControl с RangeSlider внутри
 */
const FilterRange = ({keyField, field, filedState, onChangeHandler}: IProps) => {
    const rangeState = Array.isArray(filedState) && filedState?.length ? filedState : null;
    const range = rangeState
        ? {
            min: +rangeState[0].toString().replace(">", ""),
            max: +rangeState[1].toString().replace("<", "")
        }
        : {min: field.data.min, max: field.data.max};

    const isValidRange = IsValidRangeUtil(range.min, range.max);

    const isValidFieldRange = IsValidRangeUtil(field.data.min, field.data.max);

    if (!isValidRange || !isValidFieldRange) return null;

    return (
        <DropdownControl
            className="dropdown-range"
            width="280px"
            slotHeader={<>{field.title}</>}
            slotContent={
                <RangeSlider
                    key={`slider-${range.min}-${range.max}`}
                    min={Number(field.data.min)}
                    max={Number(field.data.max)}
                    values={[
                        range.min,
                        range.max
                    ]}
                    onChange={(range) => {
                        onChangeHandler(range, keyField, FilterFieldTypeEnum.range);
                    }}
                />}
        />

    );
};

export default FilterRange;
